import { render, staticRenderFns } from "./RemoveCard.vue?vue&type=template&id=41571e56&scoped=true"
import script from "./RemoveCard.vue?vue&type=script&lang=js"
export * from "./RemoveCard.vue?vue&type=script&lang=js"
import style0 from "./RemoveCard.vue?vue&type=style&index=0&id=41571e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41571e56",
  null
  
)

export default component.exports